
<template>
  <div class="form-group" :class="{'input-group': hasIcon}">
    <slot name="label">
      <label v-if="label" class="control-label">
        {{label}}
      </label>
    </slot>
    <slot name="addonLeft">
      <span v-if="addonLeftIcon" class="input-group-addon">
        <i :class="addonLeftIcon"></i>
      </span>
    </slot>
    <div :class="{'div-stf-select-not-allowed': $attrs.disabled || $attrs.readOnly}">
      <stf-select
        :value="value"
        v-bind="$attrs"
        class="form-control"
        aria-describedby="addon-right addon-left"
        @input="onSelect">
          
          <div slot="label" v-text="placeholder"></div>
          <div slot="value">
            <div v-if="value">
               <span v-text="selectedText"></span>
            </div>
          </div>
          <div slot="search-input">
              <input v-model="searchString" @keydown.enter.prevent="selectFirst">
          </div>
          <section class="options delivery_order__options">
              <stf-select-option  
               v-for="item of options" :key="item.id"
               v-if="checkFilter(item)"
               :value="item"
               :class="{'stf-select-option_selected': item.id === value}"
               >
                  <span v-text="getItemText(item)"></span>
              </stf-select-option>
          </section>
        </stf-select>
      </div>
    <slot></slot>
    <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-addon">
        <i :class="addonRightIcon"></i>
      </span>
    </slot>
  </div>
</template>
<script>
  import {StfSelect, StfSelectOption} from 'stf-vue-select'
  import 'stf-vue-select/dist/lib/stf-vue-select.min.css'
  
  export default {
    components: {
      StfSelect,
      StfSelectOption
    },
    inheritAttrs: false,
    name: 'combo-box',
    props: {
      label: String,
      value: [String, Number],
      addonRightIcon: String,
      addonLeftIcon: String,
      options: Array,
      textField: String,
      placeholder: String
    },
    computed: {
      hasIcon () {
        const {addonRight, addonLeft} = this.$slots
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      },
      selectedText: function () {
        var selItem = this.$props.options.find(item => item.id === this.$props.value)
        return selItem ? this.getItemText(selItem) : ''
      }
    },
    data () {
      return {
        searchString: ''
      }
    },
    methods: {
      checkFilter (item) {
        if (!this.$data.searchString) {
          return true
        } else {
          return (this.getItemText(item).toUpperCase().indexOf(this.$data.searchString.toUpperCase()) !== -1)
        }
      },
      onSelect (item) {
        this.$emit('input', item.id)
      },
      selectFirst (e) {
        var firstItem = this.$props.options.find(el => this.getItemText(el).toUpperCase().indexOf(e.target.value.toUpperCase()) !== -1)
        if (firstItem) {
          this.$emit('input', firstItem.id)
        } else {
          this.$emit('input', null)
        }
        this.$data.searchString = ''
      },
      getItemText (item) {
        if (!this.$props.textField) {
          return item.text
        } else {
          return item[this.$props.textField]
        }
      }
    }
  }
</script>
<style>
.stf-select__inner-wrapper{
  background-color: initial;
  padding: 2px;
}
.stf-select__value{
  font-size: initial;
  font-weight: initial;
  line-height: initial !important;
}
.stf-select__placeholder{
  padding: 2px;
  line-height: 1 !important;
  font-size: initial;
  color: #DDDDDD;
}
.stf-select__options{
  margin-top:8px;
  border-right:1px solid rgba(136,138,163,.3);
  border-left:1px solid rgba(136,138,163,.3);
}
.stf-select__container input{
  font-size: initial !important;
  margin-top: -4px;
}
.div-stf-select-not-allowed{
  cursor: not-allowed;
}
.stf-select[disabled],.stf-select[readonly]{
  pointer-events:none;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/ComboBox.vue